import { LoadingIndicatorsState } from "@idw-types/state/loading-indicators-state";
import { LoadingIndicatorsActionTypes, LoadingIndicatorsActions } from "../actions/loading-indicators-actions";

export const initialLoadingIndicatorsState: LoadingIndicatorsState = {
    activeLoadingIndicators: []
};

export const loadingIndicatorsReducer = (
    state: LoadingIndicatorsState = initialLoadingIndicatorsState,
    action: LoadingIndicatorsActions
): LoadingIndicatorsState => {
    switch (action.type) {
        case LoadingIndicatorsActionTypes.ADD_LOADING_INDICATOR:
            return {
                ...state,
                activeLoadingIndicators: [...state.activeLoadingIndicators, action.payload.loadingIndicatorUUID]
            };
        case LoadingIndicatorsActionTypes.REMOVE_LOADING_INDICATOR:
            return {
                ...state,
                activeLoadingIndicators: state.activeLoadingIndicators.filter(ali => ali !== action.payload.loadingIndicatorUUID)
            };
        default:
            return state;
    }
};